function RoundedCheckBox({ 
  className, 
  color = "#D9D9D9", 
  height = 20, 
  width = 20 
}) {

  return (
    <svg 
      className={className}
      width={ width }
      height={ height }
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="18" height="18" rx="4" stroke={color} stroke-width="2"/>
    </svg>

  );
}

export { RoundedCheckBox };
